import { memo } from "react";

interface Props {
  feature: { layerId: string; properties: Record<string, unknown> } | null;
  onClose: () => void;
}

function GenericFeatureCardImpl({ feature, onClose }: Props) {
  if (!feature) return null;
  const p = feature.properties;
  
  // Try to find a sensible name
  const name = String(p.nameEn || p.name || p.nameTh || p.title || p.NAME_T || p.id || "Selected Feature");
  const altName = p.nameTh && p.nameTh !== name ? String(p.nameTh) : null;
  
  // Format properties for display
  const entries = Object.entries(p).filter(([k, v]) => 
    v != null && 
    typeof v !== "object" && 
    k !== "name" && k !== "nameEn" && k !== "nameTh" && k !== "title" && k !== "NAME_T" && k !== "id"
  );

  return (
    <aside className="building-card" role="dialog" aria-label={`Feature: ${name}`}>
      <header className="building-card-head">
        <div>
          <span className="eyebrow mono">{feature.layerId.toUpperCase().replace(/-/g, " ")}</span>
          <h3 className="building-card-title">{name}</h3>
          {altName && <div className="building-card-alt">{altName}</div>}
        </div>
        <button onClick={onClose} aria-label="Close" className="building-card-close mono">
          ESC
        </button>
      </header>
      <dl className="building-card-meta mono" style={{ maxHeight: "400px", overflowY: "auto" }}>
        {entries.map(([k, v]) => (
          <div key={k} style={{ display: "contents" }}>
            <dt>{k.toUpperCase().replace(/_/g, " ")}</dt>
            <dd style={{ wordBreak: "break-all" }}>{String(v)}</dd>
          </div>
        ))}
        {p.id !== undefined && p.id !== null && (
          <div style={{ display: "contents" }}>
            <dt>ID</dt>
            <dd className="mono" style={{ wordBreak: "break-all" }}>{String(p.id)}</dd>
          </div>
        )}
      </dl>
    </aside>
  );
}

export const GenericFeatureCard = memo(GenericFeatureCardImpl);
